namespace Nobox {

    @Serenity.Decorators.registerEditor()
    export class NotifServerEditor extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, object> {

        constructor(hidden: JQuery, opt?: Serenity.LookupEditorOptions) {
            super(hidden, opt);
            this.addItem({ id: "All", text: "All" });
            this.addItem({ id: "Id", text: "Id" });
            this.addItem({ id: "Sg", text: "Sg" });
        }
        getLookup() {
            var lookup = {} as Q.Lookup<object>;
            lookup.items = [];
            lookup.itemById = {};
            lookup.idField = "id";
            lookup.textField = "text";
            return lookup;
        }
    }
}